import React from 'react';

// A failed/stopping task's backend.log stays on disk after the task ends, so
// the log link should stay available past 'running' -- in particular for
// 'error', so a failure can actually be inspected instead of vanishing
// straight to a Delete button.
export function showsLog(status) {
  return status === 'running' || status === 'stopping' || status === 'error';
}

export default function TaskModal({ open, tasks, onCancel, onDelete, onSelect, onShowLog, onClose }) {
  if (!open) return null;

  const iconFor = (status) => {
    switch (status) {
      case 'running':   return process.env.PUBLIC_URL + '/processing.gif';
      case 'stopping':  return process.env.PUBLIC_URL + '/hourglass.gif';
      case 'stopped':   return process.env.PUBLIC_URL + '/red_x.png';
      case 'error':     return process.env.PUBLIC_URL + '/error.png';
      case 'done':      return process.env.PUBLIC_URL + '/green_tick.png';
      default:          return process.env.PUBLIC_URL + '/green_tick.png';
    }
  };

  const altFor = (status) => {
    switch (status) {
      case 'running':   return 'Running';
      case 'stopping':  return 'Stopping…';
      case 'stopped':   return 'Stopped';
      case 'error':     return 'Error';
      case 'done':      return 'Done';
      default:          return status || 'Unknown';
    }
  };


return (
    <>
      <div className="task-modal-overlay" onClick={onClose}></div>
      <div className="task-modal" onClick={e => e.stopPropagation()}>
        <h3>Task Progress</h3>
        <div className="task-list">
          {tasks.length === 0 && <p>No tasks</p>}
          {tasks.map(task => (
            <div key={task.id} className="task-item">
              <span
                className={`task-name${task.status === 'done' ? ' clickable' : ''}`}
                onClick={task.status === 'done' ? () => onSelect(task) : undefined}
                title={task.name}
              >
                {task.name}
              </span>

              <span className="task-status">
                <img
                  src={iconFor(task.status)}
                  alt={altFor(task.status)}
                  style={{ width: task.status === 'running' ? 40 : 20 }}
                />
              </span>

              {task.status === 'running' && (
                <button onClick={() => onCancel(task.id)}>Cancel</button>
              )}

              {task.status === 'stopping' && (
                <>
                  <button disabled>Cancel</button>
                  <span className="muted">Cancelling…</span>
                </>
              )}

              {(task.status === 'stopped' || task.status === 'error' || task.status === 'done') && (
                <button onClick={() => onDelete(task.id)}>Delete</button>
              )}

              {showsLog(task.status) && (
                <a
                  href="#"
                  className="log-link"
                  onClick={(e) => { e.preventDefault(); onShowLog(task); }}
                >
                  Show log
                </a>
              )}
            </div>
          ))}
        </div>

        <button className="close-btn" onClick={onClose}>Close</button>
      </div>
    </>
  );
}
